import { basicCustomInsightConsts } from 'actions/modules/insight';

import { basicCustomReducer } from './basic';
import { chartCustomReducer } from './chart';
import { diagramCustomReducer } from './diagram';
import { emailExportInitialState, emailExportReducer } from './emailExport';
import { inputParamsCustomReducer } from './inputParams';
import { mapCustomReducer } from './map';
import { searchCustomReducer } from './search';
import { tableCustomReducer } from './table';

export const customInitialState = {
  activePanel: undefined,
  activeView: "",
  hasAllTilesPublicAccess: false,
  
  content: basicCustomInsightConsts.INIT_CONTENT,
  initContent: undefined,
  info: {},
  initInfo: undefined,
  isDraft: false,
  datapreps: {},
  editActive: false,
  userSelectableDropdowns: {},

  image: undefined,

  dataRefAreaLeft: [],
  dataRefAreaRight: [],

  symbols: {},
  values: [],
  metadataMap: {},

  choosenDate: undefined,

  emailExportState: emailExportInitialState,

  selectedTile: undefined,
  prevSelectedTile: undefined,
  isSingleTile: false,

  inputParams: {},
  inputParamsUserSelection: {},
  tooltipData: {},
  tileOverwrite: {},
  tilePartnerAssets: {},

  isActiveInputParamsOpen: false,
  activeInputParamsId: undefined,
  
  isActiveBasketOpen: false,
  activeBasketId: undefined,
  activeFormulaWithOptionalSave: false,
  basket: {},
  
  templateParams: {},

  createDialogIsOpen: false,

  isCompareInsightOpen: false,
  compareInsightVersion: undefined
}

export const customState = (state = customInitialState, action) => {
  const newState = basicCustomReducer(state, action) || chartCustomReducer(state, action) || mapCustomReducer(state, action) || tableCustomReducer(state, action) || diagramCustomReducer(state, action) || emailExportReducer(state, action) || inputParamsCustomReducer(state, action) || searchCustomReducer(state, action)
  return newState || state;
}
